/**
 * Homepage logo — centered on hero, then pins toward banners on scroll.
 * Header stays visible from first paint (no blank intro screen).
 */
(function () {
  var CENTER_HOLD = 0.82;
  var logo = document.querySelector("[data-t-intro-logo]");
  var header = document.querySelector(".t-header");
  if (!logo) return;

  document.body.classList.add("t-is-home");
  document.body.classList.add("t-header-visible");
  if (header) header.classList.remove("t-header--minimal");

  var scrollEndEl = null;
  var introScrollEndPx = 0;
  var logoHeight = 0;
  var raf = 0;

  function measureScrollEnd() {
    scrollEndEl = document.querySelector("[data-t-scroll-end]");
    if (!scrollEndEl) {
      introScrollEndPx = 0;
      return;
    }
    var rect = scrollEndEl.getBoundingClientRect();
    var bottom = rect.bottom + window.scrollY;
    introScrollEndPx = Math.max(1, bottom - window.innerHeight);
  }

  function updateLogoSize() {
    logoHeight = logo.offsetHeight || 0;
  }

  function tick() {
    var scrollY = window.scrollY || 0;
    var vh = window.innerHeight || 1;
    var progress = introScrollEndPx > 0 ? Math.min(1, scrollY / introScrollEndPx) : 0;
    var introComplete = introScrollEndPx > 0 && scrollY >= introScrollEndPx * 0.98;

    var centerTop = vh / 2 - logoHeight / 2;
    var endTop = Math.max(centerTop, vh - logoHeight);
    var move =
      progress <= CENTER_HOLD
        ? 0
        : (progress - CENTER_HOLD) / (1 - CENTER_HOLD);
    var animatedTop = centerTop + move * (endTop - centerTop);

    var sectionCap = animatedTop;
    if (scrollEndEl) {
      var endBottom = scrollEndEl.getBoundingClientRect().bottom;
      sectionCap = Math.min(animatedTop, endBottom - logoHeight);
    }

    logo.style.top = sectionCap + "px";
    logo.style.transform = "translateX(-50%)";

    document.body.classList.toggle("t-intro-complete", introComplete);

    raf = 0;
  }

  function onScroll() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(tick);
  }

  function onResize() {
    updateLogoSize();
    measureScrollEnd();
    tick();
  }

  updateLogoSize();
  measureScrollEnd();
  tick();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);

  if (typeof ResizeObserver !== "undefined") {
    var ro = new ResizeObserver(onResize);
    ro.observe(logo);
    if (scrollEndEl) ro.observe(scrollEndEl);
    var mo = new MutationObserver(function () {
      measureScrollEnd();
      if (scrollEndEl) ro.observe(scrollEndEl);
      tick();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
